import { z } from 'zod';

import { BlogPostEntrySchema } from './blog-post.validator';
import { ContentfulSysSchema } from './contentful-sys.validator';
import { DynamicPageEntrySchema } from './dynamic-page.validator';
import { LandingPageEntrySchema } from './landing-page.validator';
import { SystemPageEntrySchema } from './system-page.validator';

export const NavigationItemEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    label: z.string(),
    description: z.string().optional().nullable(),
    icon: z.string().optional().nullable(),
    page: z.union([DynamicPageEntrySchema, LandingPageEntrySchema, SystemPageEntrySchema, BlogPostEntrySchema]).optional().nullable(),
    slug: z.string().optional().nullable(),
    queryParameters: z.string().optional().nullable(),
    externalUrl: z.string().optional().nullable(),
    openInNewTab: z.boolean(),
    accessType: z
      .array(z.enum(['Customer', 'Guest', 'Internal', 'Pending', 'Public']))
      .optional()
      .nullable(),
    identifier: z.string().optional().nullable()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});
